import React from 'react';
import { SectionLabel } from './SectionLabel';
import { bonuses, BONUS_VALUE } from '../data/offer';
export function Bonuses() {
  return <section className="w-full border-y border-line bg-cream" aria-labelledby="bonuses-heading" data-id="element-52" data-mp="pjg1foyvelv4">
      <div className="mx-auto max-w-5xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-53" data-mp="asz3iflg2e2z">
        <SectionLabel data-id="element-54" data-mp="fsv7ieu565ij">Included today at no extra cost</SectionLabel>

        <h2 id="bonuses-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.75rem]" data-id="element-55" data-mp="1tvkfbma1yoh">
          Five free bonuses
        </h2>

        <p className="mt-4 text-[15px] text-muted sm:mt-5 sm:text-lg" data-id="element-56" data-mp="3o2n2jujn9yhj">
          Real value ${BONUS_VALUE} — yours completely free when you order
          today.
        </p>

        <ol className="mt-9 divide-y divide-line border-y border-line sm:mt-12" data-id="element-57" data-mp="1mai563jdm8zf">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-x-8 gap-y-4 py-7 sm:grid-cols-[11rem_1fr] sm:items-start sm:gap-y-5 sm:py-8" data-id="element-58" data-mp="1r9l5xbsbpt1l">
              <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="mx-auto w-44 rounded-lg bg-white object-cover sm:mx-0 sm:w-full" data-id="element-59" data-mp="3dfldt6v46y1y" />

              <div data-id="element-60" data-mp="3n4mwj4t1ntjm">
                <div className="flex flex-wrap items-center gap-2.5 sm:gap-3" data-id="element-61" data-mp="3n67s8xr3hij2">
                  <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-62" data-mp="2zf2csjp2gs9a">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full border border-moss/30 bg-moss-soft px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-[0.1em] text-moss" data-id="element-63" data-mp="2uitx956yix1l">
                    ${bonus.value} · Free
                  </span>
                </div>

                <h3 className="mt-3 font-display text-xl font-semibold leading-tight text-ink sm:mt-4 sm:text-2xl" data-id="element-64" data-mp="np01oz4keoct">
                  {bonus.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-muted sm:mt-3 sm:text-[15px]" data-id="element-65" data-mp="3cj6gsc65doob">
                  <span className="font-semibold text-ink" data-id="element-66" data-mp="3hhr9zrmzf839">
                    {bonus.promise}
                  </span>{' '}
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}